const TAG_MODEL_CLASS_NAME = 'Tag'
const TAG_MODEL_KEY = {
  NAME: 'name'
}

const TAG_MODEL_KEY_POINTER = TAG_MODEL_KEY.NAME

export {
  TAG_MODEL_CLASS_NAME,
  TAG_MODEL_KEY,
  TAG_MODEL_KEY_POINTER
}
